import Select from '../../../ui/select';
import Input from '../../../ui/input';
import DateInput from '../../../ui/date-input';
import Text from '../../../ui/text';
import RadioGroup from '../../../ui/radio-group';
import * as lists from '../constants';
import { useFormContext } from "react-hook-form";

function PersonalInfo() {
  const { 
    register,
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  // const watchDescribesYou = watch('describesYou');
  // const watchGender = watch('gender');
  return (
    <section className="w-full">
      <h2 className="text-xl leading-10 text-zinc-600 max-md:mt-10 max-md:max-w-full">
        <Text>Let's review some of your personal details.</Text>
      </h2>
      <div className="grid grid-cols-12 gap-5 mt-5">
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='firstName'>First Name *</Text>
          <Input
            {...register('firstName')}
            size='sm'
            label={<Text>First Name</Text>}
            placeholder="-"
            errorMessage={errors?.firstName?.message || null}
            isInvalid={errors?.firstName ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='middleName'>Middle Name</Text>
          <Input
            {...register('middleName')}
            size='sm'
            label={<Text>Middle Name</Text>}
            placeholder="-"
            errorMessage={errors?.middleName?.message || null}
            isInvalid={errors?.middleName ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='lastName'>Last Name *</Text>
          <Input
            {...register('lastName')}
            size='sm'
            label={<Text>Last Name</Text>}
            placeholder="-"
            errorMessage={errors?.lastName?.message || null}
            isInvalid={errors?.lastName ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='dateOfBirth'>Date Of Birth *</Text>
          <DateInput 
            name='dateOfBirth'
            label={<Text>Date of Birth*</Text>} 
            control={control} 
            errorMessage={errors?.dateOfBirth?.message || null}
            isInvalid={errors?.dateOfBirth ? true : false}
          />
        </div>
        {/* <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='describesYou'>What best describes you?</Text>
          <Select
            {...register('describesYou')}
            size='sm'
            label={<Text>Select</Text>}
            options={lists.describesYou}
            selectionMode="single"
            isDisabled={lists.describesYou?.length === 0}
            errorMessage={errors?.describesYou?.message || null}
            isInvalid={errors?.describesYou ? true : false}
          />
        </div> */}
        {/* {watchDescribesYou === '4' && (
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='describesYouOther'>Other *</Text>
            <Input
              {...register('describesYouOther')}
              size='sm'
              label={<Text>Other</Text>}
              placeholder="-"
              errorMessage={errors?.describesYouOther?.message || null}
              isInvalid={errors?.describesYouOther ? true : false}
            />
          </div>
        )} */}
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='sex'>Sex</Text>
          <Select
            {...register('sex')}
            size='sm'
            label={<Text>Select</Text>}
            options={lists.sex}
            selectionMode="single"
            isDisabled={lists.sex?.length === 0}
            errorMessage={errors?.sex?.message || null}
            isInvalid={errors?.sex ? true : false}
          />
        </div>   
        {/* <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='gender'>Gender</Text>
          <Select
            {...register('gender')}
            size='sm'
            label={<Text>Select</Text>}
            options={lists.gender}
            selectionMode="single"
            isDisabled={lists.gender?.length === 0}
            errorMessage={errors?.gender?.message || null}
            isInvalid={errors?.gender ? true : false}
          />
        </div> */}
        {/* {watchGender === '4' && (
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='genderOther'>Other *</Text>
            <Input
              {...register('genderOther')}
              size='sm'
              label={<Text>Other</Text>}
              placeholder="-"
              errorMessage={errors?.genderOther?.message || null}
              isInvalid={errors?.genderOther ? true : false}
            />
          </div>
        )} */}
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='race'>Race</Text>
          <Select
            {...register('race')}
            size='sm'
            label={<Text>Select</Text>}
            options={lists.race}
            selectionMode="single"
            isDisabled={lists.race?.length === 0}
            errorMessage={errors?.race?.message || null}
            isInvalid={errors?.race ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='ethnicity'>Ethnicity</Text>
          <Select
            {...register('ethnicity')}
            size='sm'
            label={<Text>Select</Text>}
            options={lists.ethnicity}
            selectionMode="single"
            isDisabled={lists.ethnicity?.length === 0}
            errorMessage={errors?.ethnicity?.message || null}
            isInvalid={errors?.ethnicity ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start gap-3'>
          <Text type='label' htmlFor='yourSpouseWork'>Does your spouse work? *</Text>
          <RadioGroup
            control={control}
            name='yourSpouseWork'
            size='sm'
            defaultValue="no"
            options={[
              { label: <Text>Yes</Text>, value: true },
              { label: <Text>No</Text>, value: false },
            ]} 
            isInvalid={!!errors?.yourSpouseWork}
            errorMessage={errors?.yourSpouseWork?.message || null}
          />
        </div>
      </div>
    </section>
  );
}

export default PersonalInfo;